<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <section
    ref="mapRef"
    :class="[
      'sectionContainer py-20 lg:py-[140px]',
      theme === 'aubergine' ? 'bg-aubergine' : 'bg-ocean',
    ]"
  >
    <header2
      :text="title"
      :is-umbraco="true"
      theme="dark"
      classes="col-start-2 col-span-12 lg:col-start-2 lg:col-span-5"
    />
    <rich-text
      v-if="text"
      :text="text"
      :is-umbraco="true"
      theme="dark"
      classes="col-start-2 col-span-10 lg:col-start-7 lg:col-span-5"
    />
    <div
      class="col-start-2 col-span-full lg:col-start-2 lg:col-span-12 mt-[60px] overflow-hidden"
    >
      <map-svg :theme="theme" classes="w-[140%] h-full lg:w-full" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { computed, toRefs } from "vue";
import Header2 from "@/components/Typography/Header2.ce.vue";
import RichText from "@components/Typography/RichText.ce.vue";
import MapSvg from "@molecules/Map/MapSVG.vue";
import { IMapProps } from "@/types/components/IMapComponentProps";

const props = withDefaults(defineProps<IMapProps>(), {
  theme: "aubergine",
  isUmbraco: false,
});
const { title, text, isUmbraco, theme } = toRefs(props);
</script>
```
